import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/authService';

/**
 * Role Protected Route Component
 * Restricts access to routes based on user role
 * @param {Array<string>} allowedRoles - Array of roles allowed to access this route
 * @param {React.Component} children - Component to render if authorized
 */
const RoleProtectedRoute = ({ allowedRoles, children }) => {
  const userRole = authService.getUserRole();

  console.log('🔒 Role Protection Check:', {
    userRole,
    allowedRoles,
    isAllowed: allowedRoles.includes(userRole)
  });

  // Check if user's role is in the allowed roles list
  if (!allowedRoles.includes(userRole)) {
    console.warn(`⚠️ Access denied! User role "${userRole}" not in allowed roles:`, allowedRoles);
    // Redirect to appropriate dashboard based on their actual role
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RoleProtectedRoute;
